import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NUMBER_3 } from '~shared/constants';
import { FiltersApplicationEventService } from '~shared/services/filters-application-event.service';
import { AttributeOption } from '~shared/models';
import { Attribute } from '~app/modules/filters/models';

@Component({
  selector: 'app-attribute-modal',
  templateUrl: './attribute-modal.component.html',
  styleUrls: ['./attribute-modal.component.scss']
})
export class AttributeModalComponent {
  indices: any[];
  attribute: Attribute;
  attributeOptions: AttributeOption[];
  attributeOptionsModalForm: FormGroup;
  numberOfColumns = NUMBER_3; // number of columns to show
  optionsPerColumn;
  isMobileOrTablet = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AttributeModalComponent>,
    private filtersApplicationEventService: FiltersApplicationEventService,
    @Inject(MAT_DIALOG_DATA) public data: { filterFields: any, attribute: Attribute, isMobileOrTablet: boolean }
  ) {
    const { filterFields, attribute, isMobileOrTablet } = this.data;

    this.isMobileOrTablet = isMobileOrTablet;
    this.attribute = attribute;
    // sorting the attribute option array
    this.attributeOptions = [...attribute.options].sort((a, b) => a.name.localeCompare(b.name));
    // getting number of attribute options to show per column for desktop view
    this.optionsPerColumn = Math.ceil(this.attributeOptions.length / this.numberOfColumns);
    this.indices = Array(this.numberOfColumns).fill(0).map((_val, index) => index * this.optionsPerColumn);

    this.attributeOptionsModalForm = this.fb.group({ ...filterFields });
  }

  onClose() {
    this.dialogRef.close();
  }

  onFiltersApplied() {
    const dialogResult = {
      attribute: this.attribute,
      formValue: this.attributeOptionsModalForm.value
    };

    this.dialogRef.close(dialogResult);
  }

  onOptionSelected(option: AttributeOption, $event: any ) {
    if(!$event.target.checked) {
      return;
    }

    this.filtersApplicationEventService.attributeFromModal(this.attribute.id, option.name);
  }
}
